import { jsx as s } from "react/jsx-runtime";
import t from "./filter-chip.module.less.js";
const a = ({ label: o, onClick: e, isSelected: i, isDisabled: n }) => /* @__PURE__ */ s(
  "button",
  {
    disabled: !!n,
    onClick: () => {
      typeof e == "function" && e();
    },
    className: [t.chip, t.lineHeight, "body-base my-0", i ? t.selected : ""].join(" "),
    children: o
  }
);
export {
  a as FilterChip,
  a as default
};
